import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { NewInputText } from '../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import Switch from 'react-switch';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { IconBoxReusableComponent } from '../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent';
import { ReusableOnboardingMapButton } from '../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';

const OtherSettingsExp = ({ formik, expType, ageRestriction, props }) => {
  const allSeatingArea = useSelector((state) => {
    return !isEmpty(
      state.onboarding?.onboard_subscription_details?.casual_dining_status
        ?.seating?.general_seating?.seating_areas
    )
      ? state.onboarding.onboard_subscription_details?.casual_dining_status
          ?.seating?.general_seating?.seating_areas
      : [];
  });

  const seatingArea = useSelector((state) => {
    return state.category?.seating_area?.filter((ele) =>
      allSeatingArea.includes(ele._id)
    );
  });

  const onSeatingPreference = (icon) => {
    if (!formik?.values?.seatingPreference?.includes(icon.title)) {
      formik.setFieldValue('seatingPreference', [
        ...formik.values.seatingPreference,
        icon.title,
      ]);
    } else {
      let ind = formik.values.seatingPreference.filter(
        (ele) => ele !== icon.title
      );
      formik.setFieldValue('seatingPreference', ind);
    }
  };

  const bookingSlots = [15, 30, 45, 60];

  const autoCancelSlots = [5, 10, 15];

  //console.log('formik.values', formik.values)

  return (
    <React.Fragment>
      <Form>
        <div className="f20-700 text-dark mt-4 mb-5">
          Do you provide accessibility?
        </div>
        {ageRestriction ? null : (
          <>
            <div className="row margin-between-toggler mb-4 pt-2">
              <div className="col-4">
                <div>
                  <div className="f15-700">Highchair</div>
                  <p className="left-toggle-bottom-text-head"></p>
                </div>
              </div>
              <div className="col-2">
                <div className="d-flex align-items-center">
                  <div className={`f12-500 mr-2`}>No</div>
                  <Switch
                    onChange={() =>
                      formik.setFieldValue(
                        'highchairAccess',
                        !formik.values.highchairAccess
                      )
                    }
                    checked={formik.values.highchairAccess}
                    offColor="#EEEEEE"
                    onColor="#EEEEEE"
                    offHandleColor="#212121"
                    onHandleColor="#59F832"
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={15}
                    width={41}
                    boxShadow="-2px 0px 5px #0000003B"
                    activeBoxShadow="-2px 0px 5px #0000003B"
                    id="material-switch"
                  />
                  <div className="f12-500 ml-2">Yes</div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="row margin-between-toggler mb-4 pt-2">
          <div className="col-4">
            <div className="f15-700">Handicap Access</div>
          </div>
          <div className="col-2">
            <div className="d-flex align-items-center">
              <div className={`mr-2`}>No</div>
              <Switch
                onChange={() =>
                  formik.setFieldValue(
                    'handicapAccess',
                    !formik.values.handicapAccess
                  )
                }
                checked={formik.values.handicapAccess}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              />
              <div className={` ml-2`}>Yes</div>
            </div>
          </div>
        </div>
        <div className="row margin-between-toggler mb-4 pt-2">
          <div className="col-4 col-md-4 col-sm-6 col-xs-6">
            <div className="f15-700">Auto Accept</div>
          </div>
          <div className="col-2 col-md-4 col-sm-6 col-xs-6">
            <div className="d-flex align-items-center">
              <div className={`mr-2`}>No</div>
              <Switch
                onChange={() =>
                  formik.setFieldValue('autoAccept', !formik.values.autoAccept)
                }
                checked={formik.values.autoAccept}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
                disabled={true}
              />
              <div className={`ml-2`}>Yes</div>
            </div>
          </div>
        </div>
        {formik.values.autoAccept ? (
          <div className="row margin-between-toggler mb-4 pt-2">
            <div className="col-4 col-md-4 col-sm-12 col-xs-12">
              <div className="f15-700">Auto Accept Pax Limit</div>
              <div className="f11-400 opacity5">
                (Request with pax below this will automatically be accepted for
                Experience, any number above this threshold will go to pending
                for action)
              </div>
            </div>
            <div className="col-2 col-md-2 col-sm-12 col-xs-12 input-number-field-with-up-down-arrows">
              <TextField
                id="autoAcceptPax"
                label="Max seats for booking"
                type="number"
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                maxLength={3}
                variant="outlined"
                className={`w-100 ${
                  formik.errors.autoAcceptPax && formik.touched.autoAcceptPax
                    ? 'enError'
                    : ''
                }`}
                name="autoAcceptPax"
                helperText={
                  formik.errors.autoAcceptPax && formik.touched.autoAcceptPax
                    ? formik.errors.autoAcceptPax
                    : 'Min pax must be greater than or equal to Min seats for booking'
                }
                error={
                  formik.errors.autoAcceptPax && formik.touched.autoAcceptPax
                }
                onChange={formik.handleChange}
                value={formik.values.autoAcceptPax}
                onBlur={formik.handleBlur}
              />
            </div>
            <div className="col-1 col-md-1 col-sm-2 col-xs-2 flexcenter">
              <div className="f12-500 m-auto">Pax</div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="row margin-between-toggler mb-4 pt-2">
          <div className="col-4 col-md-4 col-sm-12 col-xs-12">
            <div className="f15-700">Booking - Same Day Allowed?</div>
            <div className="f11-400 opacity5">
              (Last Booking as per the Booking time slot below no is at closing
              time)
            </div>
          </div>
          <div className="col-2 col-md-4 col-sm-6 col-xs-6">
            <div className="d-flex align-items-center">
              <div className={`mr-2`}>No</div>
              <Switch
                onChange={() =>
                  formik.setFieldValue(
                    'sameDayBooking',
                    !formik.values.sameDayBooking
                  )
                }
                checked={formik.values.sameDayBooking}
                offColor="#EEEEEE"
                onColor="#EEEEEE"
                offHandleColor="#212121"
                onHandleColor="#59F832"
                handleDiameter={24}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={41}
                boxShadow="-2px 0px 5px #0000003B"
                activeBoxShadow="-2px 0px 5px #0000003B"
                id="material-switch"
              />
              <div className={`ml-2`}>Yes</div>
            </div>
          </div>
        </div>
        {expType === 'SPECIAL' && (
          <>
            <div className="row margin-between-toggler mb-4 pt-2">
              <div className="col-4 col-md-4 col-sm-12 col-xs-12">
                <div className="f15-700">Maximum Days ahead</div>
                <div className="f11-400 opacity5">
                  (Maximum days ahead booking can be made)
                </div>
              </div>
              <div className="col-2 col-md-2 col-sm-12 col-xs-12 ">
                <NewInputText
                  extraClass="mb-1"
                  name="maxDaysAhead"
                  maxLength={5}
                  inputType="number"
                  labelText="eg. 180"
                  controlClass="maxDaysAhead"
                  onChange={formik.handleChange}
                  value={formik.values.maxDaysAhead}
                  onBlur={formik.handleBlur}
                />
              </div>
              <div className="col-1 col-md-1 col-sm-2 col-xs-2 flexcenter">
                <div className="f12-500 m-auto">Days</div>
              </div>
            </div>
            <div className="row margin-between-toggler mb-4 pt-2">
              <div className="col-4 col-md-4 col-sm-12 col-xs-12">
                <div className="f15-700">Booking Time Slot</div>
                <div className="f11-400 opacity5">
                  (Users will be given slots in these intervals to make
                  experience request during open hours)
                </div>
              </div>
              <div className="col-2 col-md-2 col-sm-12 col-xs-12">
                <FormControl variant="outlined" className={'w-100'}>
                  <Select
                    name="bookingTimeSlot"
                    id="bookingTimeSlot"
                    className={`w-100 ${
                      formik.errors.bookingTimeSlot &&
                      formik.touched.bookingTimeSlot
                        ? 'enError outlined-Minutes'
                        : 'outlined-Minutes'
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.bookingTimeSlot}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors.bookingTimeSlot &&
                      formik.touched.bookingTimeSlot
                    }
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {bookingSlots.map((ele) => (
                      <MenuItem value={ele}>{ele}</MenuItem>
                    ))}
                  </Select>
                  {formik.errors.bookingTimeSlot &&
                  formik.touched.bookingTimeSlot ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.bookingTimeSlot}
                    </div>
                  ) : null}
                </FormControl>
              </div>
              <div className="col-1 col-md-1 col-sm-2 col-xs-2 flexcenter">
                <div className="f12-500 m-auto">Minutes</div>
              </div>
            </div>
            <div className="row margin-between-toggler mb-4 pt-2">
              <div className="col-4 col-md-4 col-sm-12 col-xs-12">
                <div className="f14-700">Auto Cancel</div>
                <div className="f11-400 opacity5">
                  Pending Orders have to be accepted within Specified period
                  Otherwise it will be cancelled
                </div>
              </div>
              <div className="col-2 col-md-2 col-sm-12 col-xs-12">
                <FormControl variant="outlined" className={'w-100'}>
                  <Select
                    name="autoCancel"
                    id="autoCancel"
                    className={`w-100 ${
                      formik.errors.autoCancel && formik.touched.autoCancel
                        ? 'enError outlined-Minutes'
                        : 'outlined-Minutes'
                    }`}
                    onChange={formik.handleChange}
                    value={formik.values.autoCancel}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.errors.autoCancel && formik.touched.autoCancel
                    }
                    IconComponent={KeyboardArrowDownIcon}
                  >
                    {autoCancelSlots.map((ele) => (
                      <MenuItem value={ele}>{ele}</MenuItem>
                    ))}
                  </Select>

                  {formik.errors.autoCancel && formik.touched.autoCancel ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.autoCancel}
                    </div>
                  ) : null}
                </FormControl>
              </div>
              <div className="col-1 col-md-1 col-sm-2 col-xs-2 flexcenter">
                <div className="f12-500 m-auto">Minutes</div>
              </div>
            </div>
            <Form.Row className="margin-top-section">
              <div className="col-10 col-sm-10 col-md-12 col-lg-3 col-xl-3">
                <Form.Label className="party-size-label f14-700">
                  Seating Preference
                </Form.Label>
                <p className="f11-400 opacity5 seating-preference">
                  Seating is a subject to availability. Your Preference will be
                  considered.
                </p>
              </div>
            </Form.Row>
            <Form.Row className="margin-top-section">
              {seatingArea?.map((icon, index) => (
                <div
                  className="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 mb-3"
                  key={index}
                >
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      formik?.values?.seatingPreference?.includes(icon.title)
                        ? 'onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle'
                        : 'onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type'
                    }
                    title={icon.title}
                    onClick={() => onSeatingPreference(icon)}
                  />
                  {/* <IconBoxReusableComponent
                    classSection={
                      formik.values.seatingPreference === icon.title
                        ? "seating-Iconbox-reusable seating-Iconbox-reusable-active"
                        : "seating-Iconbox-reusable"
                    }
                    title={icon.title}
                    iconText={icon.title}
                    onClick={(e) =>
                      formik.setFieldValue("seatingPreference", icon.title)
                    }
                  /> */}
                </div>
              ))}
            </Form.Row>
            <Form.Text className="text-muted input-component-bottom">
              <div className="text-danger text-capitalize">
                {formik.errors.seatingPreference}
              </div>
            </Form.Text>
          </>
        )}
      </Form>
    </React.Fragment>
  );
};

export default OtherSettingsExp;
